// extracted by mini-css-extract-plugin
export default {"container":"PlotsContainer_container__RVarj"};